module.exports = __webpack_public_path__ + "img/pin.a17feb39.svg";